import { Link } from '@tanstack/react-router';

import { cn } from '~/lib/utils';

interface ProviderCardProps {
  to: string;
  params: Record<string, string>;
  name: string;
  description: string;
  logoSrc: string;
  isConnected: boolean;
  connectedLabel: string;
}

export function ProviderCard({
  to,
  params,
  name,
  description,
  logoSrc,
  isConnected,
  connectedLabel
}: ProviderCardProps): React.ReactNode {
  return (
    <Link
      to={to}
      params={params}
      className={cn(
        'block rounded-lg border border-border bg-card p-5 shadow-sm transition-colors hover:bg-accent',
        isConnected && 'border-green-200'
      )}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start justify-between gap-2">
          <img src={logoSrc} alt={name} className="size-16 rounded-xl object-contain" />
          {isConnected && (
            <span className="inline-flex shrink-0 items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
              {connectedLabel}
            </span>
          )}
        </div>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </Link>
  );
}
